import axios from "../../privateApi";

export const deleteAllPlayers = () => {
  axios.delete("/user-players");
};
